<template>
  <div>
    <b-navbar
      v-if="playerId"
      toggleable="lg"
      type="light"
      class="navbar-absolute navbar-transparent"
    >
      <b-container>
        <b-navbar-brand href="#">
          <b-img width="30" src="/assets/img/Velios_Icon_White_Sm.png" />
        </b-navbar-brand>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="navbar-toggler-icon"></span>
          <span class="navbar-toggler-icon"></span>
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <b-navbar-nav class="navbar-nav">
            <b-nav-item :to="{ name: 'home' }" exact>Home</b-nav-item>
            <b-nav-item :to="{ name: 'players' }" exact>Leaders</b-nav-item>
            <b-nav-item active-class="active"
              :to="{
                name: 'world',
                params: { 
                  id_dev: '08743cb7-bb56-4584-9877-86de84fbbc95', 
                  id: 'e67839d7-1037-482c-97e6-429dd8751ccd'
                },
              }">
              Pound Zero
            </b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <!-- <b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
          </b-nav-form>-->

            <b-nav-item-dropdown v-if="isPlayerAdmin" text="Admin" right>
              <b-dropdown-item :to="{ name: 'admin-players' }"
                >Players
              </b-dropdown-item>
              <b-dropdown-item :to="{ name: 'admin-worlds' }"
                >Worlds</b-dropdown-item
              >
              <b-dropdown-item :to="{ name: 'admin-quests' }"
                >Quests</b-dropdown-item
              >
              <b-dropdown-item :to="{ name: 'admin-quest-efforts' }"
                >Efforts</b-dropdown-item
              >
              <b-dropdown-item :to="{ name: 'admin-quest-ranks' }"
                >Ranks</b-dropdown-item
              >
              <b-dropdown-item :to="{ name: 'admin-rides' }"
                >Rides</b-dropdown-item
              >
            </b-nav-item-dropdown>

            <b-spinner v-if="isLoading" variant="light"></b-spinner>

            <b-nav-item-dropdown v-if="playerId" right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <em>{{ (player && player.name) || "Not logged in" }}</em>
              </template>
              <b-dropdown-item
                :to="{ name: 'player', params: { id: playerId } }"
                >Profile</b-dropdown-item
              >
              <b-dropdown-item :to="{ name: 'playerSettings' }">Account Settings</b-dropdown-item>
              <b-dropdown-item @click="signOut()">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item v-else :to="{ name: 'login' }">Log In</b-nav-item>
          </b-navbar-nav>
        </div>
      </b-container>
    </b-navbar>
    <!-- <div style="height:80px"></div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Auth } from "aws-amplify";
import { BImg } from "bootstrap-vue";

export default {
  components: { BImg },
  computed: {
    ...mapState({
      isLoading: (state) => state.isLoading,
      player: (state) => state.session.player,
    }),
    isPlayerLoggedIn() {
      return this.$store.getters['session/isPlayerLoggedIn'];
    },
    playerId() {
      return this.player && this.player.id;
    },
    isPlayerAdmin() {
      return this.isPlayerLoggedIn && false;
    }
  },
  methods: {
    signOut() {
      Auth.signOut();
      console.log(`Signing out`);
    },
  },
};
</script>

<style>
</style>